import type { ReactElement } from 'react';
import { formatDateTime, prettyLabel } from '@/lib/format.js';

type HistoryRow = {
  id?: unknown;
  createdAt?: unknown;
  type?: unknown;
  delta?: unknown;
  userDisplayName?: unknown;
};

type Props = {
  history: HistoryRow[];
};

export function HistorySection({ history }: Props): ReactElement {
  return (
    <section id="section-history" className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
      <h2 className="mb-4 text-lg font-semibold text-slate-950">History</h2>
      {history.length === 0 ? (
        <p className="text-sm text-slate-500">No adjustments yet.</p>
      ) : (
        <table className="min-w-full text-sm">
          <thead className="text-left text-xs uppercase text-slate-500">
            <tr>
              <th className="py-2">When</th>
              <th className="py-2">Type</th>
              <th className="py-2">Delta</th>
              <th className="py-2">By</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100">
            {history.map((h) => (
              <tr key={String(h.id)}>
                <td className="py-2">{formatDateTime(String(h.createdAt))}</td>
                <td className="py-2">{prettyLabel(String(h.type))}</td>
                <td className="py-2">{String(h.delta)}</td>
                <td className="py-2">{String(h.userDisplayName ?? '—')}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </section>
  );
}
